import { render } from "./ChatMgButton.vue?vue&type=template&id=298b098e&scoped=true"
import script from "./ChatMgButton.vue?vue&type=script&lang=js"
export * from "./ChatMgButton.vue?vue&type=script&lang=js"

import "./ChatMgButton.vue?vue&type=style&index=0&id=298b098e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298b098e"]])

export default __exports__